"use client";

import { useEffect, useRef } from "react";
import { gsap } from "../../lib/gsap-register";
import styles from "../styles/MouseTracker.module.css";

export default function MouseTracker() {
  const flairRef = useRef(null);

  const TRACKER_IMG = "https://imagedelivery.net/LOBxX7gyPpyC22XVZKaoOw/93a2fe1a-6a0c-48ac-af1d-70ae659fe200/public";

  useEffect(() => {
    if (!flairRef.current) return;
    // Center the flair
    gsap.set(flairRef.current, { xPercent: -50, yPercent: -50 });

    // Create quickTo setters
    const xTo = gsap.quickTo(flairRef.current, "x", { duration: 0.4, ease: "power3" });
    const yTo = gsap.quickTo(flairRef.current, "y", { duration: 0.4, ease: "power3" });

    // Mousemove handler
    const handleMouseMove = (e) => {
      xTo(e.clientX);
      yTo(e.clientY);
    };
    window.addEventListener("mousemove", handleMouseMove);

    // Cleanup
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  return (
    <img
      ref={flairRef}
      className={styles.flair + " flair--3"}
      src={TRACKER_IMG}
      alt="Mouse Tracker"
      draggable={false}
    />
  );
} 